import {
  FETCH_COMMUNITY_REQUEST, FETCH_COMMUNITY_RESPONSE,
  SAVE_COMMUNITY_RESPONSE,
  LIST_COMMUNITIES_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// communityId -> {community}
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case FETCH_COMMUNITY_REQUEST:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          isLoading: true,
        },
      }

    case SAVE_COMMUNITY_RESPONSE:
    case FETCH_COMMUNITY_RESPONSE:
      return {
        ...state,
        [action.community.id]: {
          ...action.community,
          isLoading: false,
        },
      }

    case LIST_COMMUNITIES_RESPONSE: {
      const s = { ...state }
      const communities = action.communities || []
      communities.forEach((c) => {
        s[c.id] = {
          ...c,
          isLoading: false,
        }
      })
      return s
    }
    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
